<template>
			<div id="page-content" class="admin-sidebar">
				<div class="component-padding">
					
					<div id="products-admin-options">
						<h1>New Proposals</h1>
						<div>
							<p>Supplier</p>
							<select name="fabrianne">
								<option value="">All</option>
								<option value="">Phelix Systems</option>
								<option value="">Fabrianne Inc</option>
								<option value="">Ast Corps</option>
							</select>
						</div>
					</div>
					
					<div class="products-list">
						<div class="col-md-4 product-item-admin" v-for="n in 9">
							<img src="static/images/j.jpeg" />
							<p>Supplier: <strong>Phelix Systems</strong></p>
							<p>Product Code: <strong>6SGHA14</strong></p>
							<p>Price: <strong>Php 140.00</strong> <small>FOB</small></p>
							<a href="#">View Product</a>
						</div>
					</div>
				</div>
			</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// AdminProposal.vue?9a263266